/**
 * API endpoints para Equipment (Equipos)
 * Base URL: /api/equipment/
 */

import { GET, POST, PUT, PATCH, DELETE } from "../config";

/**
 * Listar equipos
 */
export const list = async (page = 1, filters = {}) => {
  let url = `equipment/equipment/?page=${page}&page_size=50`;
  if (filters.branch) url += `&branch=${filters.branch}`;
  if (filters.equipment_type)
    url += `&equipment_type=${filters.equipment_type}`;
  if (filters.equipment_status)
    url += `&equipment_status=${filters.equipment_status}`;
  if (filters.category) url += `&category=${filters.category}`;
  if (filters.is_active !== undefined) url += `&is_active=${filters.is_active}`;
  if (filters.search) url += `&search=${encodeURIComponent(filters.search)}`;
  const response = await GET(url);
  return response.data;
};

export const get = async (id) => {
  const response = await GET(`equipment/equipment/${id}/`);
  return response.data;
};

export const create = async (data) => {
  const response = await POST("equipment/equipment/", data);
  return response.data;
};

export const update = async (id, data) => {
  const response = await PUT(`equipment/equipment/${id}/`, data);
  return response.data;
};

export const partialUpdate = async (id, data) => {
  const response = await PATCH(`equipment/equipment/${id}/`, data);
  return response.data;
};

export const remove = async (id) => {
  const response = await DELETE(`equipment/equipment/${id}/`);
  return response.data;
};

/**
 * Mediciones de equipos
 */
export const listMeasurements = async (equipmentId) => {
  const response = await GET(`equipment/equipment/${equipmentId}/measurements/`);
  return response.data;
};

export const addMeasurement = async (equipmentId, data) => {
  const response = await POST(`equipment/equipment/${equipmentId}/add_measurement/`, data);
  return response.data;
};

export const getMeasurement = async (id) => {
  const response = await GET(`equipment/measurements/${id}/`);
  return response.data;
};

export const updateMeasurement = async (id, data) => {
  const response = await PUT(`equipment/measurements/${id}/`, data);
  return response.data;
};

export const deleteMeasurement = async (id) => {
  const response = await DELETE(`equipment/measurements/${id}/`);
  return response.data;
};

const equipmentApi = {
  list,
  get,
  create,
  update,
  partialUpdate,
  remove,
  listMeasurements,
  addMeasurement,
  getMeasurement,
  updateMeasurement,
  deleteMeasurement,
};

export default equipmentApi;

